@if (hires.length) {
  <div layout-vertical margin-bottom>
    <rt-heading variant="heading large">
      {{ 'app.requisitions.hires.heading' | translate }}
    </rt-heading>
    <rt-heading variant="subheading normal">
      {{ 'app.requisitions.hires.subheading' | translate }}
    </rt-heading>
  </div>
} @else {
  <rt-empty-state
    [icon]="'hired'"
    [title]="'app.requisitions.hires.empty_state.title' | translate"
    [desc]="'app.requisitions.hires.empty_state.description' | translate"
    variant="default"
    margin-top
  />
}

@for (filledOpening of hires; track trackById($index, filledOpening)) {
  <div margin-bottom>
    <rt-requisitions-hired-candidate-card
      [filledOpening]="filledOpening"
      [canViewCandidateProfile]="canViewCandidateProfile"
      [canUnassignCandidates]="canUnassignCandidates"
      (unassignCandidate)="unassignCandidate($event)"
    />
  </div>
}
